var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkday(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE5\xB7\xA5\xE4\xBD\x9C\xE6\x97\xA5\xE5\xBF\x97-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xE6\xA4\xAD\xE5\x9C\x86\xE5\xBD\xA2",
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#749FFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xE5\xBD\xA2\xE7\x8A\xB6\xE7\xBB\x93\xE5\x90\x88",
    d: "M22.2588 8.00205C23.1959 8.00205 23.5929 8.39898 23.5929 8.89207V23.112C23.5929 23.6031 23.1939 24 22.2588 24H14.5883V8.00205H22.2588ZM13.6982 8V23.998H10.7049C10.2138 23.998 9.8169 23.601 9.8169 23.11V21.332H9.96217C10.9443 21.332 11.7402 20.5361 11.7402 19.556C11.7402 18.5739 10.9422 17.778 9.96217 17.778H9.8169V14.222H9.92943C10.9095 14.222 11.7054 13.4281 11.7054 12.446C11.7054 11.4639 10.9095 10.668 9.92943 10.668H9.8169V8.89207C9.8169 8.39898 10.2138 8.00205 10.7049 8H13.6982ZM10.5862 18.666C10.9443 18.666 11.2328 19.0629 11.2328 19.554C11.2328 20.0471 10.9422 20.446 10.5862 20.4419H8.64657C8.28851 20.4419 8.00002 20.045 8.00002 19.554C8.00002 19.0629 8.28851 18.666 8.64657 18.666H10.5862ZM10.5862 11.5601C10.9443 11.5601 11.2328 11.957 11.2328 12.4481C11.2328 12.9371 10.9422 13.3361 10.5842 13.3361H8.64452C8.28647 13.3361 7.99798 12.9391 8.00001 12.4481C8.00001 11.957 8.28851 11.5601 8.64657 11.5601H10.5862Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkday);
export default __webpack_public_path__ + "static/media/workday.081fbe71c178f10a6764d345ef6a0678.svg";
export { ForwardRef as ReactComponent };